import script from "./issueForm.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./issueForm.component.vue?vue&type=script&lang=ts&setup=true"

import "./issueForm.component.vue?vue&type=style&index=0&id=64042ae2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64042ae2"]])

export default __exports__